import { render } from "./CardCpfRM.vue?vue&type=template&id=6539b88c"
import script from "./CardCpfRM.vue?vue&type=script&lang=js"
export * from "./CardCpfRM.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__